import React from 'react';

const SvgComment = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" {...props}>
    <path
      d="M8.06 1c3.898 0 7.058 2.063 7.058 5.775 0 4.74-5.389 7.566-6.75 8.205a.213.213 0 0 1-.092.02.22.22 0 0 1-.217-.223v-1.845a.392.392 0 0 0-.383-.388C3.956 12.414 1 10.366 1 6.775 1 3.063 4.16 1 8.06 1"
      stroke="#999"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgComment;
